'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dom = require('../utils/dom.js');

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  props: {
    value: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      isShow: false,
      elWidth: 0
    };
  },

  watch: {
    style: function style() {
      this.isShow = true;
    }
  },
  computed: {
    isLast: function isLast() {
      return this.value >= this.$parent.max;
    },
    isFirst: function isFirst() {
      return this.value <= this.$parent.min;
    },
    style: function style() {
      var style = {
        color: this.color || (this._isDiablo ? '#797c7e' : '#8E969B'),
        opacity: this.isShow ? 1 : 0
      };
      var p = this.$parent;
      var left = (this.value - p.min) / p.scope * p.width + p._trackHeight / 2;
      if (p.isGradientBar) left = left + 4.5 - this.elWidth / 2;
      style.left = left + 'px';

      // 防止超出的情况
      if (this.isFirst) {
        delete style.left;
        if (this.elWidth && p._trackHeight / 2 < this.elWidth / 2) {
          style.left = this.elWidth / 2 + 'px';
        } else {
          style.left = p._trackHeight / 2 + 'px';
        }
      }
      // 防止超出的情况
      if (this.isLast) {
        delete style.left;
        if (this.elWidth && p._trackHeight / 2 < this.elWidth / 2) {
          style.right = this.elWidth / 2 + 'px';
        } else {
          style.right = p._trackHeight / 2 + 'px';
        }
      }
      return style;
    }
  },
  mounted: function mounted() {
    if (this.isFirst || this.isLast) this.initElWidth();
  },

  methods: {
    initElWidth: function initElWidth() {
      var _this = this;

      var el = this.$refs['dof-slider-scale'];
      (0, _dom.getBoundingClientRect)(el, function (res) {
        res.result && (_this.elWidth = res.size.width);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-slider-scale/index.vue
// module id = 389
// module chunks = 0 1